import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { Store } from "@ngrx/store";
import { tap } from "rxjs";
import { AppActions } from "../ngrx/app/app.reducer";

export const httpInterceptor: HttpInterceptorFn = (request, next) => {
  const store: Store = inject(Store);

  return next(request).pipe(
    tap({
      error: (error: HttpErrorResponse) => {
        // Echo out any client (4xx) or server (5xx) range error codes
        if (error.status === 0 || (error.status >= 400 && error.status <= 599)) {
          store.dispatch(
            AppActions.OpenDialog({
              title: `HTTP Error ${error.status}`,
              message: `
              <div>
                <div class='mb-2'><strong>${error.url}</strong></div>
                <div class='mb-2'><em>${error.statusText}</em></div>
                <div><em>${error.error?.title}</em></div>
              </div>`,
              modal: true,
            })
          );
        }
      },
    })
  );
};
